import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme({
  styles : {
    global: {
      '.csv-download': {
        padding: '0 !important',
        margin: '0 !important',
        height: '100% !important',
        width: '100% !important',
        textColor: 'gray.800 !important',
        color: 'gray.800 !important',
        fontSize: '12px !important',
        lineHeight: '100% !important',
        fontWeight: '700 !important',
        borderRadius: '10px !important',
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'center',
      }
    }
  },
  fonts: {
    body: 'Poppins, sans-serif',
    heading: 'Poppins, sans-serif',
    mono: 'Poppins, sans-serif',
  },
  breakpoints: {
    mobileSmall: '20em',
    mobileMedium: '23.4375em',
    mobileLarge: '26.5625em',
    tablet: '48em',
    notebook: '64em',
    computer: '90em',
    '4k': '160em',
  },
  colors: {
    parkoff: {
      orange: {
        300: '#FFBE3E',
        400: '#FF9B3E',
      },
      red: {
        400: '#EE4C65',
      },
      gray: {
        400: '#A4A4A4',
        800: '#242A34',
      },
      teal: {
        400: '#3CAE92',
      },
    },
  },
})
